define('taoQtiItem/qtiCreator/widgets/static/modalFeedback/states/Sleep',['taoQtiItem/qtiCreator/widgets/states/factory', 'taoQtiItem/qtiCreator/widgets/states/Sleep'], function(stateFactory, SleepState){
    
    return stateFactory.create(SleepState, function(){}, function(){});
    
});
